import * as React from "react";
import { ChangeEvent, useState } from "react";
import i18next from "i18next";
import { PageSize } from "@geo/print-service-api";
import { printPost } from "./printTools";
import { useMapContext } from "../../Contexts/MapContext";
import { Select } from "../../Elements/Select";
import { PopupButton } from "../../Elements/PopupButton";
import { IFormat, pageOrientation, usePrintContext } from "../../Contexts/PrintContext";
import { PrintOptions } from "./PrintOptions";
import { PrintResult } from "./PrintResult";
import { PrintFrame } from "./PrintFrame";
import "./PrintWidget.scss";
import { WidgetInput } from "../Widget/WidgetInput";

export const PrintWidget = (): JSX.Element => {
    const { configA } = useMapContext();
    const { loading, setLoading, useLegend, useVectors, setPrintUrl, format, setFormat } = usePrintContext();

    const [title, setTitle] = useState<string>("");

    const print = () => {
        setLoading(true);
        setPrintUrl(undefined);

        const useDefaultTitle =
            configA.print.useDefaultTitleWhenEmpty !== undefined ? configA.print.useDefaultTitleWhenEmpty : true;
        const newTitle = title ? title : useDefaultTitle ? i18next.t("print.printExport") : " "; //TODO: hack here by adding whitespace, on serverside there seems to be default title which is used if provided string is empty

        printPost(configA, newTitle, format.value as PageSize, useLegend, useVectors, onError).then(
            (response) => {
                if (response && response.status === 200) {
                    setLoading(false);
                    setPrintUrl(configA.print.url.replace(configA.print.endpoint.url, "") + "/" + response.data.file);
                }
            },
            () => onError()
        );
    };

    const onError = () => {
        setLoading(false);
        setPrintUrl("error");
    };

    return (
        <>
            <div className="scrollable-content-container print-widget">
                <div className="scrollable-content">
                    <div className="widget-popup-header">{i18next.t("print.title")}</div>
                    <WidgetInput
                        classname="print-title"
                        label={i18next.t("print.inputTitle")}
                        value={title}
                        onChange={(e) => setTitle(e.target.value)}
                        maxLength={200}
                    />
                    <Format format={format} setFormat={setFormat}></Format>
                    <PrintOptions />

                    <div className="print-button">
                        <PopupButton
                            title={loading ? i18next.t("print.export") : i18next.t("print.preparePrint")}
                            onClick={print}
                            loading={loading}
                        />
                    </div>
                    <PrintResult />
                </div>
            </div>
            <PrintFrame />
        </>
    );
};

const Format = ({ format, setFormat }: { format: IFormat; setFormat: CallableFunction }) => {
    const onClickGroup = (e: ChangeEvent<HTMLSelectElement>) => {
        const groupValue = pageOrientation.find((o) => o.label === e.target.value);
        setFormat(groupValue);
    };
    return (
        <div className="print-page-format">
            <label>{i18next.t("print.settings")} </label>
            <Select
                title={i18next.t("print.settings")}
                config={{ field: "searchGroup" }}
                options={pageOrientation}
                defaultValue={format.value}
                onChange={onClickGroup}
            />
        </div>
    );
};
